import { useState } from 'react';
import clsx from 'clsx';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

export interface ISidebarProps {
  title: string;
  icon: React.ReactNode;
  isHidden?: boolean;
  children: React.ReactNode;
}

export const SidebarItem = (props: ISidebarProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (props.isHidden) return null;
  return (
    <div className='mb-2 pt-2 border-b border-b-gray-200 last:border-b-0 last:mb-0 last:pt-0 cursor-pointer'>
      <div className='min-h-11 mb-2 pb-2 py-4 flex' onClick={() => setIsOpen((prev) => !prev)}>
        <div
          className={clsx(
            'w-5 h-5 mr-3 flex-none flex items-center justify-center text-center text-xl transition ease-in-out',
            isOpen ? 'text-primary' : 'text-slate dark:text-white hover:text-slate hover:dark:text-gray',
          )}
        >
          {props.icon}
        </div>
        <Text className='flex-auto'>{props.title}</Text>
        <div
          className={clsx(
            'w-5 h-5 flex-none text-xl flex items-center justify-center text-center mr-3',
            isOpen ? 'transition ease-in rotate-90 ' : 'transition ease-in -rotate-90',
          )}
        >
          <Icon icon={<ChevronIcon />} />
        </div>
      </div>
      <div className={clsx(!isOpen ? 'hidden' : 'block pt-3')}>{props.children}</div>
    </div>
  );
};
